import { HOST } from "../constants/HostConstants";

export const commentReport = async (
  comment_id,
  reporter_user_id,
  reason,
  details
) => {
  try {
    const res = await fetch(`${HOST}/api/comment/commentReport`, {
      method: "POST",
      body: JSON.stringify({ comment_id, reporter_user_id, reason, details }),
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    return data;
  } catch (err) {
return null;
  }
};
